import { useCallback, useEffect, useState } from "react";
import { NumOneIcon } from "@/shared/icons";
import { Confirm } from "@/shared/ui";
import toast from "@/domains/toasts/helpers/toast";
import useBuySlot from "@/domains/account/hooks/useBuySlot";
import useGetUser from "@/domains/account/hooks/useGetUser.ts";
import AccountCharLocked from "@/domains/account/components/char/AccountCharLocked";

export default function AccountCharLockedContainer() {
  const { buySlotHandler, isPending, isCompleted } = useBuySlot();
  const { getUser } = useGetUser();
  const [open, setOpen] = useState(false);

  const openHandler = useCallback(() => {
    setOpen(true);
  }, []);

  const closeHandler = useCallback(() => {
    setOpen(false);
  }, []);

  useEffect(() => {
    if (isCompleted) {
      closeHandler();
      getUser();
      toast.success("Разблокирован новый слот для персонажа");
    }
  }, [closeHandler, getUser, isCompleted]);

  return (
    <>
      <AccountCharLocked onClick={openHandler} />
      <Confirm open={open} onConfirm={buySlotHandler} onCancel={closeHandler} pending={isPending}>
        <div className="w-full flex flex-col items-center text-center text-16 font-bold text-white">
          Купить слот персонажа за{" "}
          <span className="flex items-center leading-[0.75] text-accent gap-1 text-26 py-1">
            300 <NumOneIcon size={20} />?
          </span>
        </div>
      </Confirm>
    </>
  );
}
